import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import 'react-toastify/dist/ReactToastify.css';
import 'react-toggle/style.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import Toggle from 'react-toggle'
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var svValidator;
var engValidator;
var engUserInfoValidator;
var svUserInfoValidator;
class ReportSubscriberComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            RegionId: '',
            includeDetails: false,
             includeDetailsLocked: false,
        }
        this.handleInput = this.handleInput.bind(this);


    }
    componentWillMount() {

    }

/* componentDidUpdate(prevProps) {
    debugger
 let regionId= this.state.RegionId == '' ? (this.props.ReportSubscriberDetails.regionList.length > 0 ? this.props.ReportSubscriberDetails.regionList[0].ID : null) : this.state.RegionId


  const prevValue = prevProps.ReportSubscriberDetails.regionList.find(i=>i.ID===parseInt(regionId));

  //const newValue = this.props.ReportSubscriberDetails?.IsExcelReport;
  const newValue = this.props.ReportSubscriberDetails.regionList.find(i=>i.ID===parseInt(regionId));

  // Only update if API value changed
  
  if (newValue !== undefined && (newValue ? newValue.IsExcelReport:false) !== (prevValue ? prevValue.IsExcelReport:false)) {
   this.setState({ includeDetails: newValue ? newValue.IsExcelReport:false});
  
}
} */


static getDerivedStateFromProps(nextProps, prevState) {
  const regionList = nextProps.ReportSubscriberDetails.regionList;

  // If user changed checkbox manually, do NOT override it
  if (prevState.includeDetailsLocked) {
    return null;
  }

  if (regionList && regionList.length > 0) {

    const currentRegionId =
      prevState.RegionId ||
      regionList[0].ID.toString();

    const selectedRegion = regionList.find(
      r => r.ID.toString() === currentRegionId
    );

    if (selectedRegion) {
      const apiInclude = selectedRegion.IsExcelReport;

      if (apiInclude !== prevState.includeDetails) {
        return {
          includeDetails: apiInclude,
          RegionId: currentRegionId
        };
      }
    }
  }

  return null;
}

    PushNotification(data) {
      const { t } = this.props;
       
        confirmAlert({
                    title: 'Confirm to Mail Document',
                    message: `Are you sure you want to mail monthly report to ${data.FirstName} ${data.LastName}`,
                    buttons: [
                      {
                        label: `${t('First_Responder.Yes')}`,
                        onClick: () => {
                            const dtfUK = new Intl.DateTimeFormat('UK', { year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit',minute: '2-digit', second: '2-digit' });
                      let currentDate=new Date()     
        let payload={
            "UserId":data.UserId,
           // "FromDate":dtfUK.format(new Date(currentDate.getFullYear(),currentDate.getMonth(), 1)).replace(/,/g, ''),
           // "ToDate":dtfUK.format(new Date()).replace(/,/g, '')
            "FromDate": new Date(new Date(currentDate.getFullYear(),currentDate.getMonth(), 1).getTime() + 86400000).toISOString().split('T')[0],
            "ToDate": new Date().toISOString().split('T')[0]
        }
        this.props.PerUserPdfEmail(payload)
         let item = {
            RegionId: this.state.RegionId == '' ? (this.props.ReportSubscriberDetails.regionList.length > 0 ? this.props.ReportSubscriberDetails.regionList[0].ID : null) : this.state.RegionId,
        }
        setTimeout(
            () => this.props.getUserList(item),
            400
        );
                            }
                      },
                      {
                        label: `${t('First_Responder.No')}`,
                        onClick: () => {
                        }
                      }
                    ]
                  });
       
    }
    PushMail = (rowData) => {
        const { t } = this.props;

        return (
            <div>
                <span style={{ cursor: 'pointer' }} onClick={() => { this.PushNotification(rowData) }} tooltip="Push Pdf" title={'Push Document'}>
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>

            </div>

        )
    }

    notify = (message) => {
        swal({ text: message, icon: 'success' })

        // this.toastId =toast.success(message, {
        //   position: toast.POSITION.TOP_CENTER
        // });
    }

    errornotify = (message) => {
        // toast.error(message + "!", {
        //     position: toast.POSITION.TOP_CENTER
        // });
        swal({ text: message, icon: 'error' })

    };
    handleInput = (e) => {

        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            ReportSubscriberDetails:
                { ...prevState.ReportSubscriberDetails, [name]: value }
        }),)
    }
    setStatus = (rowData) => {
        if (rowData.UserLogout == "False") {
            return (<span className="box" style={{ background: '#06c706' }}></span>) // online
        }
        else if (rowData.UserLogout == "True") {
            return (<span className="box" style={{ background: '#e92828' }}></span>) //offline
        }
        else {
            return (<span className="box" style={{ background: '#000000' }}></span>) // no login yet
        }
    }
    getPhoneNumber = (data) => {
        if (data) {
            return '+' + data.CountryCode + data.PhoneNumber;
        }
    }
   
changeRegion = (e) => {
  const value = e.target.value.toString();

  this.setState({
    RegionId: value,
    includeDetailsLocked: false // allow API to update includeDetails
  });

  this.props.getUserList({ RegionId: value });
};

    isEnableEmail(event, data1) {
        const { t } = this.props;
        let data = {
            "UserId": data1.UserId,
            "IsEmailEnabled": event.target.checked

        }
        this.props.enableMap(data);
        let item = {
            RegionId: this.state.RegionId == '' ? (this.props.ReportSubscriberDetails.regionList.length > 0 ? this.props.ReportSubscriberDetails.regionList[0].ID : null) : this.state.RegionId,
        }
        setTimeout(
            () => this.props.getUserList(item),
            400
        );
    }
    emailToggle = (rowData) => {

        return (
            <div>
                <Toggle key={rowData.UserId}
                    id={rowData.UserId.toString()}
                    checked={rowData.IsEmailEnabled}
                    value={rowData.IsEmailEnabled == true ? 'on' : ''}
                    onChange={(e) => this.isEnableEmail(e, rowData)} />
            </div>

        )
    }
     handleDocType = (data) => {
  
    let payload = {
      RegionId:
        this.state.RegionId == ""
          ? this.props.ReportSubscriberDetails.regionList.length > 0
            ? this.props.ReportSubscriberDetails.regionList[0].ID
            : null
          :parseInt(this.state.RegionId),
        IsExcelReport:data,
        IsAllRegion:false
    };
     this.props.UpdateReportTypeSetting(payload)
  };
    render() {
        const { t } = this.props;
        let countryListOption;
        let countryListVal = this.props.ReportSubscriberDetails.countryList;
        let regionListOption;
        let regionList = this.props.ReportSubscriberDetails.regionList;
        if (countryListVal) {
            countryListOption = countryListVal.map((item) =>
                <option style={{ background: '#f5f1f1' }} value={item.CountryCode} key={item.CountryCode}>{item.CountryName} - {item.CountryCode}</option>
            );
        }
        if (regionList) {
            regionListOption = regionList.map((item) =>
                <option style={{ background: '#f5f1f1' }} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }

        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Region.Report Subscribers')}</h2>
                </div>
                {/* <ToastContainer /> */}
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">

                                <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div>
                                <div className="w3l_search">
                                    {header}
                                </div>
                                <div className="toggle-row  toggle-border" style={{ marginLeft: 8,maxHeight:'8vh !important' }}>
    <span className="toggle-sise"
     
    >
        <label>{t("Permissions.Send document to email as")}:</label>
      Pdf
    </span>

    <label className="custom-toggle" style={{cursor:'pointer'}} aria-label="Include Details">
     <input
  type="checkbox"
  checked={this.state.includeDetails}
  onChange={(e) => {
    const isChecked = e.target.checked;

    this.setState({
      includeDetails: isChecked,
      includeDetailsLocked: true  // 👈 user override
    });

    this.handleDocType(isChecked);
  }}
/>
      <span className="custom-toggle-slider"></span>
    </label>

    <span className="toggle-sise"
     
    >
    Excel
    </span>
  </div>
                                <div className="devicestable">


                                    <br />


                                    <DataTable
                                        className="table"
                                        value={this.props.ReportSubscriberDetails.userList}
                                        loading={this.props.ReportSubscriberDetails.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}

                                    // rowClassName={this.rowClassName}

                                    >

                                        <Column field="FirstName" header={t('First_Responder.First Name')} sortable={true} />
                                        <Column field="LastName" header={t('First_Responder.Last Name')} sortable={true} />

                                        {/* <Column field="Username" header="User Name" sortable={true} /> */}
                                        <Column field="PhoneNumber" header={t('First_Responder.Phone Number')} className="wordBreakLine" sortable={true} />
                                        <Column field="EmailId" header={t('First_Responder.Email')} className="wordBreakLine" sortable={true} />
                                        {/* <Column field="CertificateId" header={t('First_Responder.Certification ID')} className="wordBreakLine" sortable={true} />                            */}

                                        <Column header={t('Region.Enable Report Mail')} body={this.emailToggle} />
                                        <Column header={t('Region.Push Monthly Report')} body={this.PushMail} />

                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </div>
        )
    }
}
export default withNamespaces()(ReportSubscriberComponent);

